import script from "./LKProfileWindow.vue?vue&type=script&setup=true&lang=js"
export * from "./LKProfileWindow.vue?vue&type=script&setup=true&lang=js"

import "./LKProfileWindow.vue?vue&type=style&index=0&id=67d61234&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67d61234"]])

export default __exports__